<div *ngIf="users && users.length > 0" class="change-owner-dialog">
  <h3 mat-dialog-title class="dialog-title">
    Change {{data.type =='user'? 'Owner':'Secondary owner'}} of lead
  </h3>
  <form [formGroup]="ownerForm" class="owner-form">
    <div mat-dialog-content class="dialog-content">
      <div class="current-owner">
        <strong>Current Owner:</strong> {{ currentOwner }}
      </div>
      <app-select
        [options]="users"
        [displayKey]="'name'"
        [placeholder]="data.type === 'user' ? 'Select new owner (required)' : 'Select secondary owner (optional)'"
        formControlName="newOwner"
        class="owner-select"
        [required]="data.type === 'user'"
      ></app-select>
      <mat-error *ngIf="ownerForm.get('newOwner')?.hasError('required') && ownerForm.get('newOwner')?.touched" class="error-message">
        Owner is required
      </mat-error>
      <div *ngIf="data.type === 'secondaryUser'" class="helper-text">
        Leave blank to remove secondary owner
      </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
      <button mat-stroked-button (click)="close()" class="cancel-button">
        Cancel
      </button>
      <button
        mat-raised-button
        (click)="save()"
        class="save-button"
        [disabled]="!ownerForm.valid"
      >
        Save
      </button>
    </div>
  </form>
</div>